import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Modal } from 'antd';
import apiService from '../api/apiService';
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './phone-input-override.css';

function GuestModel({
  isOpen,
  onClose,
  existingData,
  onGuestAdded,
  onSave,
  hotelId,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (existingData && Object.keys(existingData).length > 0) {
      form.setFieldsValue({
        name: existingData.name || 'NA',
        phone: existingData.phone || 'NA',
        address: existingData.address || 'NA',
        email: existingData.email || 'NA',
        travel_agency: existingData.travel_agency || 'NA',
      });
    } else {
      form.resetFields();
    }
  }, [existingData, form]);

  const handleSaveAndEdit = async values => {
    const newGuestDetails = {
      name: values.name,
      phone: values.phone,
      address: values.address,
      email: values.email,
      travel_agency: values.travel_agency,
      hotel: hotelId,
    };

    try {
      let response;
      if (existingData?.id) {
        response = await apiService.put(
          `/guests/${existingData.id}/?hotel=${hotelId}`,
          newGuestDetails
        );
        toast.success('Guest updated successfully!');
      } else {
        response = await apiService.post(
          `/guests/?hotel=${hotelId}`,
          newGuestDetails
        );
        toast.success('Guest added successfully!');
        if (onGuestAdded) onGuestAdded();
      }

      if (onSave && response) onSave(response);

      handleCancel();
    } catch (error) {
      console.error('Error saving guest:', error);
      toast.error('Failed to save the guest.');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const [focus, setFocus] = useState(false);

  const customStyles = {
    inputStyle: {
      width: '100%',
      height: '40px',
      fontSize: '14px',
      borderRadius: '6px',
      border: focus ? '1px solid #1890ff' : '1px solid #d9d9d9',
      boxShadow: focus ? '0 0 0 2px rgba(24, 144, 255, 0.2)' : 'none',
      transition: 'all 0.3s',
    },
    buttonStyle: {
      borderRadius: '2px 0 0 2px',
      border: focus ? '1px solid #1890ff' : '1px solid #d9d9d9',
      borderRight: 'none',
      transition: 'all 0.3s',
      backgroundColor: '#fff',
    },
    dropdownStyle: {
      margin: '3px 0 0 -1px',
      borderRadius: '2px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
  };

  return (
    <Modal
      centered
      title={existingData?.id ? 'Edit Guest' : 'Add Guest'}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleSaveAndEdit}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter the name' }]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phone"
          rules={[
            { required: true, message: 'Please enter your phone number' },
            /* {
              validator: (_, value) => {
                if (!value || value.length < 6) {
                  return Promise.reject('Please enter a valid phone number');
                }
                return Promise.resolve();
              },
            }, */
          ]}
        >
          <PhoneInput
            country={'in'} // Default country
            /* enableSearch={true} */
            countryCodeEditable={false}
            placeholder="Enter phone number"
            inputStyle={customStyles.inputStyle}
            buttonStyle={customStyles.buttonStyle}
            dropdownStyle={customStyles.dropdownStyle}
            containerStyle={{ width: '100%' }}
            searchStyle={{ margin: '0', width: '100%', height: '30px' }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          />
        </Form.Item>

        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true, message: 'Please enter the address' }]}
        >
          <Input placeholder="Enter address" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          validateTrigger="onBlur"
          rules={[
            {
              type: 'email',
              message: 'Please enter a valid email address.',
            },
          ]}
        >
          <Input placeholder="Enter email (optional)" />
        </Form.Item>

        <Form.Item
          label="Travel Agency"
          name="travel_agency"
          rules={[
            {
              type: 'text',
              message: 'Please enter valid agency name',
            },
          ]}
          validateTrigger="onBlur"
        >
          <Input placeholder="Enter travel agency name (optional)" />
        </Form.Item>

        <div className="form-actions d-flex justify-content-end">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default GuestModel;
